import React, { Fragment, ReactElement } from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import useStyles from './styles';
import clsx from 'clsx';
import TranslatedText from '../../components/atoms/translated_text';
import { Translations } from './configuration';
import PersonIcon from '@material-ui/icons/Person';
import { withRouter } from 'react-router';
import DatatableList from './components/datatable';
import ApplicantActions from '../../redux/reducers/applicant_list_reducer/actions';
import { useDispatch } from 'react-redux';
import ModalActions from '../../redux/reducers/gl_modal_reducer/actions';
import BaseModal from '../../components/molecules/base_modal';
import { ModalIDs } from '../../redux/reducers/gl_modal_reducer/types';
import AddAplicant from './components/add_applicant';
import AddVatReturnForm from 'components/app_common/add_vatreturn';

interface IProps {}

const ApplicantsPage: React.FC<IProps> = (props) => {
  // console.log('Render ApplicantsPage');
  const classes = useStyles();
  const dispatch = useDispatch();

  const addApplicant = () => {
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_ADD_APPLICANT,
        params: {},
      })
    );
  };

  React.useEffect(() => {
    dispatch(
      ApplicantActions.fetchApplicantsAction({
        sortField: 'applicant_id',
        page: 0,
        pageSize: 25,
        order: 'asc',
      })
    );
  }, [dispatch]);

  return (
    <Fragment>
      <Paper
        className={clsx(classes.cardLayout, classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        <div className={classes.header}>
          <Box display="flex" alignItems={'center'}>
            <PersonIcon style={{ marginRight: '.75rem' }} />
            <Typography component={'p'} variant={'h6'}>
              <TranslatedText
                textMap={Translations.page_title}
                defaultText={Translations.page_title.English}
              />
            </Typography>
          </Box>
          <Box display="flex" alignItems={'center'}>
            <Button className={classes.header_actions} onClick={addApplicant}>
              <TranslatedText textMap={Translations.add_applicant} />
            </Button>
          </Box>
        </div>
      </Paper>
      <div className={classes.contentContainer}>
        <Typography component={'p'} variant={'h5'}>
          <TranslatedText
            textMap={Translations.table_title}
            defaultText={Translations.table_title.English}
          />
        </Typography>
        <DatatableList />
      </div>
      <PageModals />
    </Fragment>
  );
};

const PageModals = (): ReactElement => {
  return (
    <Fragment>
      <BaseModal
        modalID={ModalIDs.MODAL_ADD_APPLICANT}
        renderHeader={() => (
          <TranslatedText textMap={Translations.add_applicant} />
        )}
        renderContent={(props) => <AddAplicant {...props} />}
      />
      <BaseModal
        modalID={ModalIDs.MODAL_ADD_VAT_RETURN}
        renderHeader={() => <TranslatedText defaultText="Add VAT Return" />}
        renderContent={(props) => <AddVatReturnForm {...props} />}
      />
    </Fragment>
  );
};

export default withRouter(ApplicantsPage);
